import { render, staticRenderFns } from "./cms-block-footer.vue?vue&type=template&id=6c59cefe&scoped=true"
import script from "./cms-block-footer.vue?vue&type=script&lang=js"
export * from "./cms-block-footer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c59cefe",
  null
  
)

export default component.exports